import { CancellationUtil } from '@/utils/Cancellation'
import { CATEGORY_TYPE_KVG, CATEGORY_TYPE_VVG, CHANNEL_OVP } from '@/config/constants'
import Vue from '@/setup'
const { $backend } = Vue.prototype

export const CancellationHelper = {
  ...CancellationUtil,

  getPreInsurers(questions, contractStartDate) {
    const hasKvg = questions.some(q => q.kvg)
    const hasVvg = questions.some(q => q.vvg)
    const promises = []
    if (hasKvg) {
      promises.push(getPreInsurersByType(CATEGORY_TYPE_KVG, contractStartDate))
    }
    if (hasVvg) {
      promises.push(getPreInsurersByType(CATEGORY_TYPE_VVG, contractStartDate))
    }
    return Promise.all(promises)
  },

  loadCancellationQuestions(basketId, jwToken) {
    return $backend.ovp.getCancellationQuestions({ basketId, jwToken })
  },
}

function getPreInsurersByType(insurerType, contractStartDate) {
  return $backend.masterdata
    .getPreinsurers({
      channel: CHANNEL_OVP,
      contractStartDate: `${contractStartDate.substr(0, 7)}-01`,
      insurerType,
    })
    .then(preInsurers => {
      return {
        type: insurerType,
        data: preInsurers.data
          ?.map(item => {
            return {
              value: item.id,
              text: item.name,
            }
          })
          .sort((a, b) => (a.text >= b.text ? 1 : -1)),
      }
    })
}
